import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon3: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='114'
      height='77'
      viewBox='0 0 114 77'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='22.2827' y='18' width='81.0393' height='53.6' fill='#CCCCE6' stroke='#404040' />
      <path
        d='M60.2889 42.8702V46.6608M64.5669 42.8702V46.6608M62.455 61.1194V25M74.0435 61.1194L74.9099 65.0725H72.9893L71.5814 61.1194M50.8664 61.1194L50 65.0725H51.9206L53.3285 61.1194M74.9099 25H50V61.1194H74.9099V25Z'
        stroke='#404040'
        strokeMiterlimit='10'
      />
      <circle cx='76.7129' cy='57.2942' r='9.05859' fill='#CCCCE6' stroke='#404040' />
      <path d='M72.5781 57.7053L75.5418 59.7767L81.7285 54.6296' stroke='#404040' />
      <rect x='18.3125' y='71.2998' width='88.9786' height='4.2' fill='#CCCCE6' stroke='#404040' />
      <circle cx='17.8125' cy='17.9219' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M21.8178 19.6059C21.8178 22.0179 19.8198 23.6199 17.4798 23.6199C15.5538 23.6199 14.0958 22.5759 13.3038 21.0459L14.6358 20.1099C15.3558 21.2079 16.2018 21.8739 17.4258 21.8739C18.8478 21.8739 19.8558 20.9739 19.8558 19.6239C19.8558 18.2739 18.8658 17.5359 17.1198 17.5359H15.8058V17.0139L18.5778 13.2879H14.1498V11.5419H21.5478V12.0639L18.6678 15.9519C19.5498 16.0959 20.2878 16.4919 20.8998 17.1219C21.5118 17.7519 21.8178 18.5799 21.8178 19.6059Z'
        fill='#404040'
      />
    </svg>
  );
};

export default memo(InfoBlockIcon3);
